import { HTMLELEMENT } from '../../../EL/EL.js';
// import TABLE, { TableElementModel } from '@model/EL/table/TABLE.js';
import TGROUP from '../../../DOM/table/TGROUP/TGROUP.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
// Model Structure
export const theadAttr = makeAttrStruct([
    ['name'],
    ['class']
]);
export const theadData = makeDataStruct([]);
export const theadModel = makeStruct([
    ['attributes', theadAttr],
    ['data', theadData]
]);
// Simplified Model
export function thead(name, className) {
    return {
        attributes: theadAttr(name, className),
        data: theadData()
    };
}
/** A TABLE Header Group */
export default class THEAD extends TGROUP {
    //declare public node: TABLE<TableElementModel>;
    // constructor(node: TABLE<TableElementModel>, model: M) {
    constructor(node, model) {
        super(node, HTMLELEMENT.THEAD, model);
        this.addClass('table-header');
    }
}
